import script from "./ProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileView.vue?vue&type=script&setup=true&lang=js"

import "./ProfileView.vue?vue&type=style&index=0&id=40c69150&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c69150"]])

export default __exports__